import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function terminal(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@terminal/FIND_TERMINAL':
      case '@terminal/UPDATE_TERMINAL':
      case '@terminal/DELETE_TERMINAL':
      case '@terminal/STORE_TERMINAL':
      case '@terminal/TERMINAIS_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@terminal/SUCCESS_REMOVE':
      case '@terminal/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@terminal/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.terminais;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@terminal/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.terminal;
        break;
      }

      case '@terminal/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
